import { createI18n } from "vue-i18n";
import fr from "@/assets/i18n/fr.json";
import en from "@/assets/i18n/en.json";
import de from "@/assets/i18n/de.json";
import nl from "@/assets/i18n/nl.json";

const getDefaultLocale = () => {
  const available = ["fr", "en", "de", "nl"];
  return navigator.languages.find((l) => available.includes(l)) ?? "fr";
};

const i18n = createI18n({
  locale: localStorage.getItem("kwa_locale") ?? getDefaultLocale(),
  messages: { fr, en, de, nl },
});

export default i18n;
